import { ColumnDef } from '@tanstack/react-table';
import { Currency } from '@website/types/graphqlOperations';
import { Maybe } from 'graphql/jsutils/Maybe';
import { DateTime } from 'luxon';
import Link from 'next/link';
import { Badge } from 'react-bootstrap';
import { connectHits } from 'react-instantsearch-dom';
import DataTable from '../DataTable';

export type DepartingGroupsAlgoliaHit = {
  startTimestamp: number;
  id: string;
  private: boolean;
  remainingSpaces: number;
  spacesBooked: Maybe<number>;
  trip: {
    id: string;
    title: string;
    slug: string;
    host: { id: string; urlSlug: string };
  };
  start: { zone: string; utc: string };
  end: { zone: string; utc: string };
  guestPrice: { amountZD: number; currency: Currency };
  hostPrice: { amountZD: number; currency: Currency };
  guestDeposit: { amountZD: number; currency: Currency };
};

const departingBookingsColumns: ColumnDef<DepartingGroupsAlgoliaHit>[] = [
  {
    id: 'Departing',
    header: 'Departing',
    accessorFn: (row) =>
      DateTime.fromISO(row.start.utc).toLocaleString(DateTime.DATE_MED),
  },
  {
    id: 'Trip',
    header: 'Trip',
    cell: ({ row }) => (
      <Link target="_blank" href={`/trips/${row.original.trip.slug}`}>
        {row.original.trip.title}
      </Link>
    ),
  },
  {
    id: 'Booking',
    header: 'Booking',
    cell: ({ row }) => (
      <Link
        target="_blank"
        href={`/hosts/dashboard/${row.original.trip.host.urlSlug}/bookings/${row.original.id}`}
      >
        View Bookings
      </Link>
    ),
  },
  {
    id: 'Spaces Booked',
    header: 'Spaces Booked',
    accessorFn: (row) => row.spacesBooked ?? 0,
  },
  {
    id: 'Spaces Remaining',
    header: 'Spaces Remaining',
    cell: ({ row }) => {
      return (
        <>
          {row.original.remainingSpaces > 0 ? (
            row.original.remainingSpaces
          ) : (
            <Badge pill bg="success">
              fully booked
            </Badge>
          )}
        </>
      );
    },
  },
];

function AdminDepartingBookings({
  hits,
}: {
  hits: DepartingGroupsAlgoliaHit[];
}) {
  return <DataTable data={hits} columns={departingBookingsColumns} />;
}

const AdminDepartingBookingsTable = connectHits(AdminDepartingBookings);

export default AdminDepartingBookingsTable;
